<template>
  <div class="input-group">
    <select class="custom-select" :id="defaultID">
      <option selected>{{ selected }}</option>
      <option v-for="(item, index) in list" :value="item" :key="index">{{
        item
      }}</option>
    </select>
  </div>
</template>
<script>
export default {
  props: {
    id: {
      required: false,
      type: String,
      default: "defaultId"
    },
    selected: {
      required: true
    },
    list: {
      required: true,
      type: Array
    }
  },
  computed: {
    defaultID() {
      return this.id;
    }
  }
};
</script>
